import { render, staticRenderFns } from "./PersonalManager.vue?vue&type=template&id=24362730&scoped=true"
import script from "./PersonalManager.vue?vue&type=script&lang=js"
export * from "./PersonalManager.vue?vue&type=script&lang=js"
import style0 from "./PersonalManager.vue?vue&type=style&index=0&id=24362730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24362730",
  null
  
)

export default component.exports